<template>
  <rest-page :fetch-endpoint="fetchEndpoint">
    <form-section :title="$t('Profiles_Title_BasicData')">
      <div class="block-container">
        <el-row>
          <el-col v-for="(item, index) in items" :key="index" :span="12">
            <div>
              <span class="item-field-title">{{ item.label }}</span>
              <overflow-tooltip :value="validateValueEmpty(item.value)" />
            </div>
          </el-col>
        </el-row>
      </div>
    </form-section>
  </rest-page>
</template>

<script>
import RestPage from '@/common/components/rest/RestPage'
import FormSection from '@/common/components/form/FormSection'
import OverflowTooltip from '@/common/components/form/OverflowTooltip'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'BasicAttributes',

  components: {
    RestPage,
    FormSection,
    OverflowTooltip
  },

  props: {
    profileId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      model: {}
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `user-profiles/${this.profileId}`,
        handler: data => {
          this.model = data
        }
      })
    },

    items() {
      return [
        {
          label: this.$t('Profiles_Field_Num'),
          value: this.model['num'],
          show: true
        },
        {
          label: this.$t('Profiles_Field_UserId'),
          value: this.model['user_id'],
          show: this.$can('UserPersonalData::Read')
        },
        {
          label: this.$t('Profiles_Field_CustomerId'),
          value: this.model['customer_id'],
          show:
            this.$can('UserPersonalData::Read') &&
            this.$store.state.app.features.customerIdEnabled
        },
        {
          label: this.$t('Profiles_Field_Email'),
          value: this.model['email'],
          show: this.$can('UserPersonalData::Read')
        },
        {
          label: this.$t('Profiles_Field_MobileNumber'),
          value: this.model['mobile_number'],
          show: this.$can('UserPersonalData::Read')
        },
        {
          label: this.$t('Profiles_Field_WhatsappNumber'),
          value: this.model['whatsapp_number'],
          show: this.$can('UserPersonalData::Read')
        }
      ]
    }
  },

  methods: {
    validateValueEmpty(propValue) {
      if (propValue !== null && propValue !== undefined && propValue !== '') {
        return propValue
      } else {
        return '-'
      }
    }
  }
}
</script>

<style scoped>
.block-container {
  background-color: #f8fafc;
  padding: 20px 20px 0 20px;
}

.el-col.el-col-12 {
  margin-bottom: 20px;
}

.item-field-title {
  color: #a7acba;
  font-size: 14px;
  line-height: 22px;
}

>>> .label {
  font-size: 14px;
  line-height: 28px;
  color: #4b515f;
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/BasicAttributes.vue